// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';
import { auth } from '../firebase';

const Footer = ({ openAuth } = {}) => {
  const isLoggedIn = !!auth.currentUser;
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-6 sm:py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8 mb-6 sm:mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src="/logo-hmong.svg" alt="HmongHearts" className="w-9 h-9" />
              <span
                className="text-xl font-semibold"
                style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
              >
                <span className="text-white">Hmong</span>
                <span className="text-rose-400 italic">Hearts</span>
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">{t('footer.description')}</p>
          </div>
          <div>
            <h3 className="font-bold mb-4 text-sm uppercase tracking-wide text-gray-300">
              {t('footer.platform')}
            </h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <Link to="/discover" className="hover:text-white transition">
                  {t('footer.discover')}
                </Link>
              </li>
              <li>
                <Link to="/events" className="hover:text-white transition">
                  {t('footer.events')}
                </Link>
              </li>
              <li>
                {isLoggedIn ? (
                  <Link to="/members" className="hover:text-white transition">
                    {t('footer.community')}
                  </Link>
                ) : openAuth ? (
                  <button onClick={openAuth} className="hover:text-white transition">
                    {t('footer.community')}
                  </button>
                ) : (
                  <Link to="/" className="hover:text-white transition">
                    {t('footer.community')}
                  </Link>
                )}
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold mb-4 text-sm uppercase tracking-wide text-gray-300">
              {t('footer.info')}
            </h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <Link to="/mentions-legales" className="hover:text-white transition">
                  {t('footer.legalNotice')}
                </Link>
              </li>
              <li>
                <Link to="/confidentialite" className="hover:text-white transition">
                  {t('footer.privacy')}
                </Link>
              </li>
              <li>
                <Link to="/cgu" className="hover:text-white transition">
                  {t('footer.terms')}
                </Link>
              </li>
              <li>
                <button
                  onClick={() => {
                    localStorage.removeItem('analytics-consent');
                    window.location.reload();
                  }}
                  className="hover:text-white transition cursor-pointer"
                >
                  {t('footer.cookies')}
                </button>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold mb-4 text-sm uppercase tracking-wide text-gray-300">
              {t('footer.contact')}
            </h3>
            <p className="text-sm text-gray-400 mb-2">{t('footer.contactText')}</p>
            <a
              href="mailto:contact@hmonghearts.com"
              className="text-rose-400 hover:text-rose-300 transition text-sm font-semibold"
            >
              contact@hmonghearts.com
            </a>
            {isLoggedIn && (
              <Link
                to="/feedback"
                className="block mt-3 text-sm text-gray-400 hover:text-white transition"
              >
                {t('footer.feedback')}
              </Link>
            )}
          </div>
        </div>
        <div className="border-t border-gray-800 pt-4 sm:pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <div className="flex items-center gap-4">
            <p className="text-gray-500 text-xs sm:text-sm">
              © {new Date().getFullYear()} HmongHearts. {t('footer.rights')}
            </p>
            <LanguageSelector />
          </div>
          <p className="text-gray-600 text-xs">{t('footer.madeWith')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
